import React from 'react';
import NestedMenu, { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';

interface ContextMenuProps {
    menuItems: NestedMenuOptionT[];
    open: boolean;
    onClose: () => void;
    x: number;
    y: number;
}

const WidgetContextMenu = ({
    menuItems,
    x,
    y,
    open,
    onClose,
}: ContextMenuProps) =>
    open ? (
        <NestedMenu
            menuLevels={2}
            options={menuItems}
            onOptionClick={(option: NestedMenuOptionT) => {
                option.onClick(option.action);
                onClose();
            }}
            anchorPosition={{ top: y, left: x }}
            onClickAway={onClose}
        />
    ) : (
        <></>
    );

export default WidgetContextMenu;
